import React, { Fragment, useEffect, useState, useContext } from 'react'
import styled, {css} from 'styled-components';
import Cart from './Cart';
import { MetaContext } from "../context";

import {
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import { Route } from "react-router"

import { Catalog } from "./Catalog";
import { AddToCart } from './AddToCart';
import { Checkout } from './Checkout';
import { StackExpanded } from './StackExpanded';
import { Quiz } from './Quiz';
import { Stack0 } from './Stack0';


export function Store(props) {
  const context = useContext(MetaContext);

  return (
    <div>


      <Router
        // history={hist}
        >
          <Switch>
            <Route
              exact path="/clean"
              render={({history}) => {
                localStorage.clear();
                history.push('/')
                return null
            }}
            />
            <Route
              exact path="/sh"
              render={(props) => <AddToCart  />}
            />
            <Route
              exact path="/import"
              render={(props) => <>
                <Catalog stack={false} stack={true} {...props} />
                <Stack0 active={true}/>
              </>}
            />
            <Route
              exact path="/stack"
              render={(props) => <>
                <Catalog stack={false} stack={true} {...props} />
                <Stack0 active={true}/>
              </>}
            />
            <Route
              exact path={['/quiz', '/quiz/:quizId']}
              render={(props) => <>
                <Catalog {...props}/>
                <Quiz/>
              </>}
            />

            <Route
              path="/"
              render={(props) => <>
                <Catalog stack={false} {...props} />
              </>}
            />

          </Switch>

          {/* <Cart
            checkout={context.state.checkout}
            isCartOpen={context.state.isCartOpen}
            handleCartClose={context.handles.handleCartClose}
            updateQuantityInCart={context.handles.updateQuantityInCart}
            removeLineItemInCart={context.handles.removeLineItemInCart}
          /> */}

        </Router>



      {/* <Checkout/> */}

    </div>
  )
}